<template>
  <div class="summitek-header" :class="[{ bgImage: activePath != '/Home' }]">
    <div class="m-contain">
      <div class="logo">
        <img src="../../../assets/image/LOGO.png" alt="" @click="toHome" />
      </div>
      <div class="menuList">
        <div v-for="(item, index) in menuList" :key="index" :class="['mnlu_ul_home']">
          <span slot="title" :class="[{ active: activePath == item.path }]" v-if="item.children.length == 0"
            :data-guide-key="item.key"
            @click="changeMenu(item.path)">
            {{ item.name }}
          </span>
          <div class="mnlu_ul_li_pull" v-if="activePath == item.path && item.title.length > 0">
            <div class="mnlu_ul_li_pull_c">
              <div class="mnlu_ul_li_pull_div">
                <div class="mnlu_ul_li_pull_title">
                  <ul>
                    <li v-for="(it, i) in item.title" :key="i" class="hoverItem"
                      :class="{ liactive: activeIndex === i }" @click="changeMenu1(item.path, it, i)">
                      {{ it }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="loginPart">
        <div class="m-login">
          <p>
          <div class="ops">
            <!-- 新手引导入口：任何页面都可点击重新查看引导 -->
            <i
              class="el-icon-question guide-entry"
              :title="$t('guide.entryTip')"
              @click="clickGuideBtn()"
            ></i>
            <span class="loginBtn" v-show="!isLogin" @click="clickLoginBtn()">{{ $t('header.login') }}</span>
            <!-- 许可证图标 + 用户头像，放在同一 flex 容器保证对齐 -->
            <div class="user-entry" v-show="isLogin">
              <el-badge :value="unusedOrderCount" :hidden="!unusedOrderCount" class="license-badge">
                <img
                  class="license-icon"
                  src="../../../assets/image/license_query.png"
                  alt="许可申请"
                  title="许可申请"
                  @click.stop="clickPersonalCenterBtn(1)"
                />
              </el-badge>
              <el-menu class="el-menu-vertical-demo" mode="horizontal" :collapse="true">
                <el-submenu index="1">
                  <template slot="title">
                    <img @click.stop="clickPersonalCenterBtn()" src="../../../assets/image/personCenter.png" alt="">
                  </template>
                <el-menu-item index="1-1" @click="clickPersonalCenterBtn(0)">{{ $t('header.orderManage')
                }}</el-menu-item>
                <el-menu-item index="1-2" @click="clickPersonalCenterBtn(1)">{{ $t('header.licenseApply')
                }}</el-menu-item>
                <el-menu-item index="1-3" @click="clickPersonalCenterBtn(2)">{{ $t('header.invoiceManage')
                }}</el-menu-item>
                <el-menu-item index="1-4" @click="clickPersonalCenterBtn(3)">{{ $t('header.invoiceProfile') }}</el-menu-item>
                <el-menu-item index="1-5" @click="clickPersonalCenterBtn(4)">{{ $t('header.userAuth') }}</el-menu-item>
                <el-menu-item-group>
                  <el-menu-item index="1-6" @click="clickLoginBtn()">{{ $t('header.logout') }}</el-menu-item>
                </el-menu-item-group>
              </el-submenu>
            </el-menu>
            </div>

          </div>
          <div class="bilingual">
            <span :class="{ 'lang-active': currentLang === 'en' }" @click="changeLang('en')">En</span>
            <span :class="{ 'lang-active': currentLang === 'zh' }" @click="changeLang('zh')">中</span>
          </div>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import { getAllProduction } from "@/assets/API/pay";
export default {
  components: {},
  computed: {
    ...mapState("user", ["isLogin", "userInfo", "cartListCount", "unusedOrderCount"]),
  },
  data() {
    return {
      activePath: "/Home",
      activeIndex: 0,
      input: "",
      menuList: [
        {
          name: this.$t("menu.home"),
          path: "/Home",
          key: "Home",
          children: [],
          title: [],
          content: [
            [this.$t("menu.home")],
            [this.$t("menu.home")],
            [this.$t("menu.home")],
          ]
        },
        {
          name: this.$t("menu.products"),
          path: "/AllProducts",
          key: "AllProducts",
          children: [],
          title: [],
        },
        {
          name: this.$t('menu.buy'),
          path: '/Buy',
          key: "Buy",
          children: [],
          title: [],
        },
        {
          name: this.$t('menu.freeSoft'),
          path: '/freeSoft',
          key: "freeSoft",
          children: [],
          title: [],
        },
        {
          name: this.$t('menu.service'),
          path: "/Service",
          key: "Service",
          children: [],
          title: [],
          content: []
        },
        {
          name: this.$t('menu.about'),
          path: "/AboutUs",
          key: "AboutUs",
          children: [],
          title: [],
          content: []
        }
      ],
      activeName: "first",
      popoverVis: false,
      cartProjectNumber: "0",
      currentLang: localStorage.getItem('language') || 'zh'
    };
  },
  mounted() {
    this.getProduct();
    this.$bus.$on('reloadactivePath', path => {
      console.log("path", path);
      this.activePath = path;
    });
  },
  watch: {
    $route: {
      handler(newVal, oldVal) {
        let router = "";
        switch (true) {
          case ["/Home"].indexOf(newVal.path) != -1:
            router = "/Home";
            break;
          case ["/AllProducts"].indexOf(newVal.path) != -1:
            router = "/AllProducts";
            const nameToIndexMap = {
              "SummitMap": 0,
              "SummitSolid": 1,
              "SummitTerra": 2,
              "SummitLab": 3
            }
            if (!newVal.query) {
              this.activeIndex = 0
            } else {
              this.activeIndex = nameToIndexMap[newVal.query.name] !== undefined ? nameToIndexMap[newVal.query.name] : 0
            }
            break;
          case ["/Buy"].indexOf(newVal.path) != -1:
            router = "/Buy";
            break;
          case ["/Service"].indexOf(newVal.path) != -1:
            router = "/Service";
            break;
          case ["/AboutUs"].indexOf(newVal.path) != -1:
            router = "/AboutUs";
            break;
          default:
            router = this.$route.path;
            break;
        }
        this.activePath = router;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    ...mapMutations("user", ["SET_LOGINVISBILIT"]),
    hoverHeader(url) {
      this.$router.push(url);
    },
    toHome() {
      this.activePath = "/Home";
      this.$router.push({ name: "首页", path: "/Home" });
    },
    changeMenu1(path, name, index) {
      this.activeIndex = index;
      if (path == '/AllProducts') {
        let value;
        if (index == 0) {
          value = "SummitMap";
        } else if (index == 1) {
          value = "SummitSolid";
        } else if (index == 2) {
          value = "SummitTerra";
        } else if (index == 3) {
          value = "SummitLab";
        }
        this.activePath = path ? path : "";
        this.$router.push({
          path,
          query: {
            name: value
          }
        });
      }
    },
    changeMenu(item, name, index, li) {
      // 我的笔记跳转新页面 liuke 20230522
      if (item == "/FlashNote") {
        const { href } = this.$router.resolve({
          name: "我的笔记",
        });
        window.open(href, "_blank");
      } else {
        if (name) {
          // let obj = this.menuList.filter(item => item.content[index][0] == name[0])[0];
          let obj;
          this.menuList.forEach(e => {
            if (e.content[index]) {
              if (e.content[index][0] == name[0]) {
                obj = e;
              }
            }
          });

          if (obj.key == "Buy") {
            if (index == 0) {
              let value = "SummitMap";
              this.activePath = item ? item : "";
              this.$router.push(item);
              this.$router.push({
                path: item,
                query: {
                  // name: name[0],
                  value
                }
              });
            } else if (index == 1) {
              let value = "SummitSolid";
              this.activePath = item ? item : "";
              this.$router.push(item);
              this.$router.push({
                path: item,
                query: {
                  // name: name[0],
                  value
                }
              });
            } else if (index == 2) {
              let value = "SummitLab";
              this.activePath = item ? item : "";
              this.$router.push(item);
              this.$router.push({
                path: item,
                query: {
                  // name: name[0],
                  value
                }
              });
            }
          } else if (obj.key == "Service") {
            // console.log(name[index], 'jssss');
            // console.log(item, name, index, obj, li, 'ssssssss-----------');
            if (li == '增值服务') {
              // this.$router.push(
              //   {
              //     name: "软件支持",
              //     path: "/SoftwareSupport",
              //     query: {
              //       type: 1
              //     }
              //   }
              // );
              this.$router.push(
                {
                  path: "/Service",
                  query: {
                    type: 1
                  }
                }
              );
            } else if (li == '教学视频') {
              this.$router.push(
                {
                  path: "/Service",
                  query: {
                    type: 1
                  }
                }
              );

            } else if (li == '软件更新') {
              this.$router.push(
                {
                  path: "/Service",
                  query: {
                    type: 1
                  }
                }
              );

            } else if (li == '最新问题') {
              // this.$router.push(
              //   {
              //     name: "问题交流",
              //     path: "/Communicate",
              //     query: {
              //       type: 1
              //     }
              //   }
              // );
              this.$router.push(
                {
                  path: "/Service",
                  query: {
                    type: 2
                  }
                }
              );
            } else if (li == '问题解答') {
              this.$router.push(
                {
                  path: "/Service",
                  query: {
                    type: 2
                  }
                }
              );

            } else if (li == '产品') {
              // this.$router.push(
              //   {
              //     path: "/AccountSupportDetail",
              //     query: {
              //       value: "产品技巧"
              //     }
              //   }
              // );
              window.open('https://summitek.freshdesk.com/support/home');

            } else if (li == '许可证') {
              // this.$router.push(
              //   {
              //     path: "/AccountSupportDetail",
              //     query: {
              //       value: "许可证问题"
              //     }
              //   }
              // );
              window.open('https://summitek.freshdesk.com/support/home');


            } else if (li == '账号') {
              // this.$router.push(
              //   {
              //     path: "/AccountSupportDetail",
              //     query: {
              //       value: "账号解疑"
              //     }
              //   }
              // );
              window.open('https://summitek.freshdesk.com/support/home');

            } else if (li == '订阅/购买') {
              // this.$router.push(
              //   {
              //     path: "/AccountSupportDetail",
              //     query: {
              //       value: "订阅购买"
              //     }
              //   }
              // );
              window.open('https://summitek.freshdesk.com/support/home');

            } else if (li == '联系方式') {
              // this.$router.push({
              //   name: "联系我们", path: "/ContactUs"
              // });
              this.$router.push(
                {
                  path: "/Service",
                  query: {
                    type: 4
                  }
                }
              );
            }

          } else {
            this.activePath = item ? item : "";
            this.$router.push(item);
            this.$router.push({
              path: item,
              query: {
                name: name[0]
              }
            });
          }
        } else {
          // 大标题
          this.activePath = item ? item : "";
          this.$router.push(item);
          this.$router.push({
            path: item
          });
        }

      }
    },
    async logout() {
      await this.$store.dispatch("user/logout");
      localStorage.removeItem("USERINFO");
      // 退出时保持本页面
      this.$router.push("/Home");
    },
    clickLoginBtn() {
      if (!this.isLogin) {
        this.$router.push({ name: "Login", path: "/login" });
      } else {
        this.logout();
      }
    },
    // 点击引导图标：重新触发购买后引导（从订单管理那步开始）
    clickGuideBtn() {
      if (!this.isLogin) {
        // 未登录：提示用户先登录（引导需要通过订单进行，必须登录）
        this.$message.warning("请先登录后再查看新手引导");
        this.$router.push({ name: "Login", path: "/login" });
        return;
      }
      // 已登录：跳订单管理 tab 并置引导阶段为 1，由 OrderManagement 自行衔接后续步骤
      import("@/utils/guideTour").then((m) => {
        m.setAfterPayPhase(1);
        this.$router.push({
          name: "我的中心",
          path: "/PersonalCenter",
          query: { value: "order" },
        });
      });
    },
    toCart() {
      this.$router.push({ name: "购物车", path: "/cart" });
    },
    clickPersonalCenterBtn(val) {
      if (!val && val != 0) {
        this.$router.push({ name: "我的中心", path: "/PersonalCenter" });
      } else {
        this.$router.push({ name: "我的中心", path: "/PersonalCenter", query: { value: val } });
      }
    },
    toFree() {
      // 跳转到免费试用页
      let value = "free";
      this.$router.push({ name: "订阅购买", path: "/Buy", query: { value } });
      this.$bus.$emit('reloadactivePath', "/Buy");
    },
    getProduct() {
      getAllProduction({
        typename: "SummitMap",
        saletype: "online",
        enabledmark: 1
      }).then(res => {
        let contentItem = [];
        let arr = [];
        res.data.list.forEach(item => {
          arr.push(item.name);
        });
        contentItem.push(arr);
        getAllProduction({
          typename: "SummitSolid",
          saletype: "online",
          enabledmark: 1
        }).then(res1 => {
          let arr1 = [];
          res1.data.list.forEach(item => {
            arr1.push(item.name);
          });
          contentItem.push(arr1);
          getAllProduction({
            typename: "SummitLab",
            saletype: "online",
            enabledmark: 1
          }).then(res2 => {
            let arr2 = [];
            res2.data.list.forEach(item => {
              arr2.push(item.name);
            });
            contentItem.push(arr2);
            this.menuList.forEach(it => {
              if (it.key == "Buy") {
                it.content = contentItem;
              }
            });
          });
        });
      });
    },
    changeLang(lang) {
      this.currentLang = lang;
      localStorage.setItem('language', lang);
      this.$i18n.locale = lang;
      location.reload();
    }
  },
};
</script>

<style lang="scss">
.summitek-header {
  height: 80px;
  width: 100%;
  min-width: 1180px;
  position: fixed;
  top: 0;
  z-index: 11;
  background-color: #fff;
  .el-avatar {
    width: 20px;
    height: 20px;
    line-height: 20px;
    vertical-align: middle;
    margin-right: 5px;
  }

  .m-contain {
    height: 100%;
    display: flex;
    align-items: center;
    margin: 0 auto;
    max-width: 1300px;
  }

  .M_contain {
    width: 1200px;
  }

  .logo {
    width: 150px;
    font-weight: bold;
    position: relative;
    cursor: pointer;
    text-align: center;
    line-height:1;

    img {
      width: 150px;
      height: 100%;
    }

    .gotohome {
      position: absolute;
      right: -75px;
      top: 14px;
      font-size: 14px;
      color: black;
      font-weight: 400;
      cursor: pointer;
    }
  }

  .menuList {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 100%;
    margin-left: 25px;

    .mnlu_ul_home {
      display: flex;
      line-height: 30px;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      width: 125px;
      position: relative;

      .el-dropdown-link {
        color: #717172;
        font-size: 18px;
      }

      >span {
        color: #717172;
        font-size: 18px;
        text-align: center;

      }

      >span:hover {
        color: rgba(51, 105, 255, 1);
      }

      .active {
        font-weight: 600;
        color: #000;

        .el-dropdown-link {
          color: #000;
        }
      }
    }
  }

  .search {
    width: 190px;
    height: 28px;
    position: relative;
    // margin: 0 7px 0 50px;
    border-radius: 4px;
    margin-right: 20px;

    .el-input {
      width: 90%;
      margin-left: 18px;
    }

    .el-input__icon {
      line-height: 31px;
    }

    .el-input__inner {
      font-size: 12px;
      height: 28px;
      line-height: 28px;
      padding: 0;
      border-color: #3a74e2 !important;
    }
  }

  .icon-shouji {
    font-size: 24px;
    margin: 0 10px;
  }

  .loginPart {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }

  .m-login {
    font-size: 14px;
    // margin-left: 50px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    p {
      display: flex;
      align-items: center;

      .el-button {
        margin-left: 10px;
      }
    }

    .item_badge {
      margin-top: 10px;
      margin-right: 25px;
    }

    .el-icon-shopping-cart-2 {
      font-size: 25px;
    }

    .bilingual {
      display: flex;
      align-items: center;
      margin-left: 16px;
      color: #2b85e5;
      border: 2px solid #2b85e5;
      border-radius: 8px;

      span {
        cursor: pointer;
        padding: 2px 6px;
        font-size: 16px;
        transition: all 0.3s;
      }

      .lang-active {
        font-weight: bold;
        color: #fff;
        background-color: #2b85e5;
      }
    }

    .ops {
      display: flex;
      align-items: center;

      > * {
        align-self: center;
      }

      .guide-entry {
        font-size: 20px;
        color: #606266;
        cursor: pointer;
        margin-right: 16px;
        transition: color 0.2s;

        &:hover {
          color: #409eff;
        }
      }

      .loginBtn {
        width: 53px;
        height: 30px;
        opacity: 1;
        border-radius: 6px;
        background: rgba(255, 141, 26, 1);
        font-size: 16px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 30px;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        vertical-align: middle;

      }

      img {
        width: 20px;
        height: 20px;
      }

      .el-menu.el-menu--horizontal {
        border-bottom: none;
        height: 20px;
        line-height: 20px;

        /* submenu title 收缩到图标大小，与左侧 license-badge 完全等高对齐 */
        /* 注意：本 style 块非 scoped，::v-deep 不会被编译、会导致整条规则失效，故直接用后代选择器 */
        .el-submenu__title {
          height: 20px;
          line-height: 20px;
          padding: 0;
          display: inline-flex;
          align-items: center;

          img {
            width: 20px;
            height: 20px;
            vertical-align: top;
          }

          .el-submenu__icon-arrow {
            display: none;
          }
        }

        /* 下拉菜单项恢复正常可点击高度 */
        .el-menu-item {
          height: 40px;
          line-height: 40px;
        }
      }
    }

  }

  .m-haslogin {
    display: flex;
    font-size: 16px;
    color: #fff;
    // width: 109px;
    cursor: pointer;
    justify-content: flex-start;
    align-items: center;
  }

  .el-icon-search {
    cursor: pointer;
  }
}

.hoverStyle {
  p {
    font-weight: 600;
    font-size: 14px;
  }

  .popoverow {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;

    i {
      margin-right: 10px;
    }

    .el-col-11 {
      text-align: center;
      background-color: #f5f5f5;
      padding: 5px 10px;
      margin-top: 10px;
      cursor: pointer;

      &:hover {
        background-color: #f4f9ff;
        color: #386cff;
      }
    }
  }

  .el-divider--horizontal {
    margin: 14px 0;
  }

  .outLogins {
    text-align: right;
    font-weight: normal;

    span {
      cursor: pointer;

      &:hover {
        color: #386cff;
      }
    }
  }
}

.mnlu_ul_li_pull {
  // height: 200px;
  position: fixed;
  width: 100%;
  top: 80px;
  left: 0;
  background-color: rgb(255, 255, 255);

  .mnlu_ul_li_pull_c {
    width: 100%;
    // height: 200px;
    display: flex;
    flex-wrap: nowrap;
    justify-content: center;
    padding: 25px 0 20px 0;

    .mnlu_ul_li_pull_div {
      width: 1300px;

      .mnlu_ul_li_pull_title {
        width: 1300px;
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        margin-bottom: 15px;

        ul {
          width: 1200px;
          display: flex;
          font-size: 14px;
          font-weight: 400;
          letter-spacing: 0px;
          line-height: 20.27px;
          color: rgba(56, 56, 56, 1);
          text-align: left;
          vertical-align: top;

          li {
            width: 25%;
          }
        }
      }

      .mnlu_ul_li_pull_line {
        width: 1300px;
        height: 2px;
        background-color: rgba(229, 229, 229, 1);
        margin-bottom: 15px;
      }

      .mnlu_ul_li_pull_content ul li {
        font-size: 13px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 24px;
        color: rgba(56, 56, 56, 1);
        text-align: left;
        vertical-align: top;
        cursor: pointer;
      }

      .mnlu_ul_li_pull_content ul li div .hoverItem:hover {
        color: rgba(51, 140, 242, 1);
      }
    }
  }
}

.hoverItem:hover {
  color: rgba(51, 140, 242, 1);
}

.hoverItem.liactive {
  font-weight: bold !important;
  font-size: 17px !important;
  color: #000;
}

.mnlu_ul_li_link {
  font-size: 18px;
  line-height: 85px;
  display: block;
  transition: all .36s;
  color: #333;
  position: relative;
  z-index: 5;
}

/* 许可证图标 + 用户头像的公共容器：flex 水平排列并垂直居中对齐 */
.user-entry {
  display: flex;
  align-items: center;
}

/* 用户头像左侧的许可申请角标图标 */
.license-badge {
  margin-right: 16px;
  display: inline-flex;
  align-items: center;
  height: 20px;

  .el-badge__content {
    transform: translateY(-7px) translateX(7px);
    border: none;
    font-size: 11px;
    height: 16px;
    line-height: 16px;
    padding: 0 4px;
  }
}

.license-icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  transition: transform 0.2s;

  &:hover {
    transform: scale(1.1);
  }
}
</style>